import { gql } from "@apollo/client";

export const GET_FUNDS_DRIVES = gql`
  query GetFundsDrives($includeInactive: Boolean) {
    fundsDrives(includeInactive: $includeInactive) {
      id
      title
      description
      recipientUserId
      recipientName
      startDate
      endDate
      isActive
      createdBy
      createdDate
      totalContributedAmount
      totalContributionCount
    }
  }
`;

export const GET_MY_FUNDS_DRIVES = gql`
  query GetMyFundsDrives($includeInactive: Boolean) {
    myFundsDrives(includeInactive: $includeInactive) {
      id
      title
      description
      recipientUserId
      recipientName
      startDate
      endDate
      isActive
      createdBy
      createdDate
      totalContributedAmount
      totalContributionCount
    }
  }
`;

export const GET_FUNDS_DRIVE_CONTRIBUTIONS = gql`
  query GetFundsDriveContributions($fundsDriveId: Int!) {
    fundsDriveContributions(fundsDriveId: $fundsDriveId) {
      id
      fundsDriveId
      fundsDriveTitle
      senderUserId
      senderName
      recipientUserId
      recipientName
      amount
      transactionReference
      transactionDateTime
      confirmationMessage
      recipientConfirmed
      recipientConfirmedBy
      recipientConfirmedDate
      createdDate
    }
  }
`;

export const GET_MY_OUTGOING_CONTRIBUTIONS = gql`
  query GetMyOutgoingMemberTransferContributions {
    myOutgoingMemberTransferContributions {
      id
      fundsDriveId
      fundsDriveTitle
      senderUserId
      senderName
      recipientUserId
      recipientName
      amount
      transactionReference
      transactionDateTime
      confirmationMessage
      recipientConfirmed
      recipientConfirmedBy
      recipientConfirmedDate
      createdDate
    }
  }
`;

export const GET_MY_INCOMING_CONTRIBUTIONS = gql`
  query GetMyIncomingMemberTransferContributions($onlyUnconfirmed: Boolean) {
    myIncomingMemberTransferContributions(onlyUnconfirmed: $onlyUnconfirmed) {
      id
      fundsDriveId
      fundsDriveTitle
      senderUserId
      senderName
      recipientUserId
      recipientName
      amount
      transactionReference
      transactionDateTime
      confirmationMessage
      recipientConfirmed
      recipientConfirmedBy
      recipientConfirmedDate
      createdDate
    }
  }
`;

export const GET_FUNDS_DRIVE_MEMBER_STATUS = gql`
  query GetFundsDriveMemberStatus($fundsDriveId: Int!) {
    fundsDriveMemberStatus(fundsDriveId: $fundsDriveId) {
      fundsDriveId
      memberUserId
      memberName
      hasSent
      numberOfTransfers
      totalSentAmount
      lastTransferDate
    }
  }
`;

export const CREATE_FUNDS_DRIVE = gql`
  mutation CreateFundsDrive($input: CreateFundsDriveInput!) {
    createFundsDrive(input: $input) {
      isSuccess
      errorMessage
      data
    }
  }
`;

export const UPDATE_FUNDS_DRIVE_STATUS = gql`
  mutation UpdateFundsDriveStatus($input: UpdateFundsDriveStatusInput!) {
    updateFundsDriveStatus(input: $input) {
      isSuccess
      errorMessage
      data
    }
  }
`;

export const CREATE_MEMBER_TRANSFER_CONTRIBUTION = gql`
  mutation CreateMemberTransferContribution($input: CreateMemberTransferContributionInput!) {
    createMemberTransferContribution(input: $input) {
      isSuccess
      errorMessage
      data
    }
  }
`;

export const CONFIRM_MEMBER_TRANSFER_CONTRIBUTION = gql`
  mutation ConfirmMemberTransferContribution($input: ConfirmMemberTransferContributionInput!) {
    confirmMemberTransferContribution(input: $input) {
      isSuccess
      errorMessage
      data
    }
  }
`;
